<div class="overview_session">

  <mat-card class="card" *ngIf="session">

    <ng-container *ngIf="image">
      <img mat-card-image [src]="image" alt="image de la session">
    </ng-container>

    <mat-card-content>
      <div class="photo_experience" *ngIf="session?.photoExperience">
        <p>{{session?.photoExperience}}</p>
      </div>
      <div class="infos_sub_img" *ngIf="session?.practicePlace">
        <div class="icon">
          <fa-icon [icon]="getFaIcon('faMapMarkedAlt')"></fa-icon>
        </div>
        <p>
          {{session?.practicePlace}}
        </p>
      </div>

      <h4>{{session?.offerName}}</h4>
      <p *ngIf="session?.description" [innerHTML]="session?.description" class="description">
        <!-- {{session?.description | textDescription}} -->
      </p>
    </mat-card-content>

  </mat-card>


</div>